import { render, staticRenderFns } from "./EvaluatedCategories2.vue?vue&type=template&id=77cf00d3&"
import script from "./EvaluatedCategories2.vue?vue&type=script&lang=js&"
export * from "./EvaluatedCategories2.vue?vue&type=script&lang=js&"
import style0 from "./EvaluatedCategories2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports